import React from 'react'

export default function ThemedSuspense() {
  return (
    <div className="w-full h-screen p-6 flex justify-center items-center text-lg font-medium text-gray-600 dark:text-gray-400 dark:bg-gray-900">
      Carregando...
    </div>
  )
}